'use client';

import type { ForumSort } from './api';

const SORTS: { key: ForumSort; label: string }[] = [
  { key: 'hot', label: 'Hot' },
  { key: 'newest', label: 'Newest' },
  { key: 'oldest', label: 'Oldest' },
  { key: 'most_replies', label: 'Most replies' },
];

type Props = {
  value: ForumSort;
  onChange: (sort: ForumSort) => void;
};

export function DiscussionSortBar({ value, onChange }: Props) {
  return (
    <div className="discussion-sort" role="tablist" aria-label="Sort discussion">
      {SORTS.map((s) => (
        <button
          key={s.key}
          type="button"
          role="tab"
          aria-selected={value === s.key}
          className={`discussion-sort__btn${value === s.key ? ' discussion-sort__btn--active' : ''}`}
          onClick={() => onChange(s.key)}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
